module.exports = __webpack_public_path__ + "static/media/4.ffc524b1.jpg";